import React from 'react';
import Localize from 'react-intl-universal';

// MUI
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import RichTextEditor from '@components/RichTextEditor/RichTextEditor';

const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.primary,
  borderRadius: '4px',
  textAlign: 'left',
  padding: '1rem',
  overflow: 'auto'
}));

const EventTopics = ({ agendaNote }) => {
  let note = '';
  if (agendaNote?.text) {
    note = agendaNote?.text;
  }

  return (
    <StyledBox>
      <Typography variant='h6' mb={1}>
        {Localize.get('EventDetails.eventInfo')}
      </Typography>
      {note ? (
        <RichTextEditor initialValue={note} disabled isToolbarHidden maxHeight='27rem' />
      ) : (
        <Typography data-test-id={'noTopicContainer'}>
          {Localize.get('EventDetails.noTopics')}
        </Typography>
      )}
    </StyledBox>
  );
};

export default EventTopics;
